import { createContext } from 'react'
import type { RunStateStore } from '../../stores/RunStateStore'

export const RunStateContext = createContext<RunStateStore | null>(null)
